"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import SectionTitle from "../titles/SectionTitle";
import SplitText from "../titles/SplitText";
import { ServiceProcess as IServiceProcess } from "@/lib/types";
interface ProcessCardProps {
  step: IServiceProcess;
  className?: string;
  idx: number;
}
const ProcessCard = t0 => {
  const $ = _c(27);
  const {
    step,
    className,
    idx
  } = t0;
  const t1 = (idx + 1) * 10;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      zIndex: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${className} space-y-6 lg:space-y-12 process-card w-full h-full bg-accent-foreground flex flex-col justify-center`;
  let t4;
  if ($[2] !== step.number) {
    t4 = <span className="absolute -top-4 -left-5 md:-top-5 md:-left-8 text-sm md:text-xl lg:text-2xl font-black text-white tracking-tighter">{step.number}</span>;
    $[2] = step.number;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== step.title) {
    t5 = SplitText(step.title);
    $[4] = step.title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <SectionTitle title={t5} className="text-2xl md:text-4xl lg:text-5xl font-black uppercase tracking-tighter text-white text-center" />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <div className="relative inline-block">{t4}{t6}</div>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== step.description) {
    t8 = SplitText(step.description);
    $[11] = step.description;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <div className="max-w-6xl mx-auto mb-6 lg:mb-24 px-5"><p className="text-md md:text-xl lg:text-3xl font-semibold text-white">{t8}</p></div>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <div className="flex flex-col items-center relative pb-1 lg:space-y-6 space-y-4 border-b border-zinc-400">{t7}{t9}</div>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== step.subPoints) {
    t11 = step.subPoints.map(_temp);
    $[18] = step.subPoints;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <div className="w-full space-y-6"><div className="grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-2">{t11}</div></div>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t12 || $[24] !== t2 || $[25] !== t3) {
    t13 = <div style={t2} className={t3}>{t10}{t12}</div>;
    $[22] = t10;
    $[23] = t12;
    $[24] = t2;
    $[25] = t3;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};
export default ProcessCard;
function _temp(point, i) {
  return <div key={i} className={`text-sm md:text-md lg:text-lg font-bold uppercase text-white tracking-tighter
                      ${i % 2 === 0 ? "text-left" : "md:text-right"}
                    `}>{point}</div>;
}